import React from "react";
import Header from "../../screens/stdScreens/Header";
import NewSidebar from "../../screens/stdScreens/StdnewSideBar";
import { useSelector } from "react-redux";
import styles from "./stdquizresult.module.css";

const Quizstddetails = () => {
  const { userInfo } = useSelector((state) => state.readUserAuthReducer);

  console.log(userInfo?.user?.result)

  return (
    <>
      <Header user={userInfo} />
      <div className="mainDashBox">
        <div className="sideBOxhai">
          <NewSidebar className="sideContainer" />
        </div>
        <div className="bannerBOxhai">
          <div className={styles.headingdiv}>
            <h2 className={styles.heading}>Quiz Details</h2>
          </div>
          <div className={styles.infowrapper}>
            <div className={`${styles.infodiv} ${styles.green}`}>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.white}>Course Name</h3>
              </div>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.white}>Quiz Name</h3>
              </div>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.white}>Percentage</h3>
              </div>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.white}>Grade</h3>
              </div>
            </div>
          </div>
          {userInfo && userInfo?.user?.result.map((e,i) => {
            return (
<div className={styles.infowrapper} key={i}>
            <div className={`${styles.infodiv} ${styles.white}`}>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.colorgreen} >{e.name}</h3>
              </div>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.colorgreen}>{e.topic}</h3>
              </div>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.colorgreen}>{e.percentage}</h3>
              </div>
              <div style={{width:'25%',textAlign:'center'}}>
                <h3 className={styles.colorgreen}>{e.grade}</h3>
              </div>
            </div>
          </div>
            )
          })}
          
        </div>
      </div>
    </>
  );
};

export default Quizstddetails;
